module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/feature01-32bf2cf2d5085b248d13f8399171eecb.png";